import Vue from "vue";
import routes from "./routes";
import VueRouter from "vue-router";

import routeMiddlewares from "./middlewares";
import { isTestEnv } from "@/utils/common.utils";

/**
 * Stops initialising vuerouter in test mode for test suites
 */
if (!isTestEnv()) Vue.use(VueRouter);

/**
 * Vue router
 */
const router = new VueRouter({
  routes,
});

/**
 * Router middleware
 */
router.beforeEach(routeMiddlewares.auth);

export default router;
